import { createClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * Unico cliente de Supabase de la aplicacion. No hay backend intermedio: las lecturas
 * van con `.schema(x).from(tabla)` y toda escritura que toca plata, con funciones de la
 * base (`rpc`). Ningun componente lo importa: pasa por los `*.service.ts` de cada feature.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});

/** Dominio interno que Supabase Auth exige como mail; el usuario nunca lo ve. */
export const DOMINIO_INTERNO = '@ayc.local';
